<template>
  <el-aside style="background-color: #f1f5f8; height: 100vh" width="300px">
    <div class="logo">
      <img alt="" src="../../assets/logo.png" style="width: 143px" />
    </div>

    <div
      :class="menuActiveIndex === -1 ? 'active' : ''"
      class="space-name"
      @click="goIndex"
    >
      <img
        :src="menuActiveIndex === -1 ? homeIcon2 : homeIcon"
        alt=""
        class="el-icon-s-home"
      />
      <span>{{ userInfo.spaceName }}</span>
    </div>

    <!--  menu-->
    <div class="menu-wrap">
      <div v-for="(item, index) in menuList" :key="index" class="menu">
        <div v-if="index === 0" class="menu-top-msg">使用空间</div>
        <div v-if="index === 4 && !item.hide" class="menu-top-msg">
          管理空间
        </div>
        <div
          v-if="!item.hide"
          :class="menuActiveIndex === index ? 'active' : ''"
          class="menu-item"
          @click="changeMenu(item, index)"
        >
          <img
            :src="menuActiveIndex === index ? item.img2 : item.img"
            alt=""
            class="el-icon-s-home"
          />
          <span>{{ item.name }}</span>
        </div>
      </div>

      <div class="menu-top-msg" style="padding: 20px 50px">
        {{ userInfo.spaceName }}小程序
      </div>

      <img
        alt=""
        :src="`data:image/png;base64,${userInfo.spaceQrCode}`"
        style="width: 160px; margin-left: 50px; margin-bottom: 20px"
      />
    </div>
  </el-aside>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "wan-menu",

  data() {
    return {
      menuActiveIndex: -1,
      homeIcon: require("../../assets/menu/lb-home1.png"),
      homeIcon2: require("../../assets/menu/lb-home2.png"),
      menuList: [
        {
          name: "产品与服务",
          route: "/productService?type=productService",
          img: require("../../assets/menu/lb-product1.png"),
          img2: require("../../assets/menu/lb-product2.png"),
        },
        {
          name: "档务空间",
          route: "/productService?type=fileSpace",
          img: require("../../assets/menu/lb-document1.png"),
          img2: require("../../assets/menu/lb-document2.png"),
        },
        // {
        //   name: "学习空间",
        //   route: "/productService?type=learningSpace",
        //   img: require("../../assets/menu/lb-study1.png"),
        //   img2: require("../../assets/menu/lb-study2.png"),
        // },
        {
          name: "团队与客户",
          route: "/teamCustomer",
          img: require("../../assets/menu/lb-team_kehu1.png"),
          img2: require("../../assets/menu/lb-team_kehu2.png"),
        },
        {
          name: "资源管理",
          route: "/productService?type=resourceManagement",
          hide: true,
          img: require("../../assets/menu/lb-product1.png"),
          img2: require("../../assets/menu/lb-product2.png"),
        },
        {
          name: "档务分类",
          route: "/fileClass",
          hide: true,
          img: require("../../assets/menu/lb-document1.png"),
          img2: require("../../assets/menu/lb-document2.png"),
        },
        {
          name: "空间图库",
          route: "/spaceImages",
          hide: true,
          img: require("../../assets/menu/lb-ku1.png"),
          img2: require("../../assets/menu/lb-ku2.png"),
        },
        {
          name: "团队管理",
          hide: true,
          route: "/teamManage",
          img: require("../../assets/menu/lb-team1.png"),
          img2: require("../../assets/menu/lb-team2.png"),
        },
        {
          name: "客户信息",
          hide: true,
          route: "/customerInfo",
          img: require("../../assets/menu/lb-kehu1.png"),
          img2: require("../../assets/menu/lb-kehu2.png"),
        },
        {
          name: "空间付费",
          hide: true,
          route: "/spacePay",
          img: require("../../assets/menu/lb-pay1.png"),
          img2: require("../../assets/menu/lb-pay2.png"),
        },
      ],
      tipsName: "",
    };
  },

  computed: {
    ...mapState(["userInfo"]),
  },

  mounted() {
    console.log(this.$route.fullPath);
    // 默认选中当前菜单
    this.menuActiveIndex = this.menuList
      .map((item) => item.route)
      .indexOf(this.$route.fullPath);

    // 设置头部标题名称
    let h = new Date().getHours();
    this.tipsName =
      h < 12 ? "上午好！" : h > 12 && h < 20 ? "下午好！" : "晚上好！";

    // 设置头部标题名称
    this.$store.commit(
      "setHeaderTitle",
      this.menuActiveIndex === -1
        ? this.userInfo.principal + "，" + this.tipsName
        : this.menuList[this.menuActiveIndex].name
    );

    // 设置菜单权限
    this.menuList.forEach((item) => {
      if (item.hide) {
        const purview =
          this.userInfo && this.userInfo.purview
            ? this.userInfo.purview.split(",")
            : [];
        item.hide = !purview.includes("1") && !purview.includes("60");
      }
    });
  },

  methods: {
    // 跳转首页
    goIndex() {
      if (this.menuActiveIndex === -1) return;
      this.menuActiveIndex = -1;
      this.$store.commit(
        "setHeaderTitle",
        this.userInfo.principal + "，" + this.tipsName
      );
      this.$router.push("/");
    },

    // 选择按钮
    changeMenu(item, index) {
      if (this.menuActiveIndex === index) return;
      // 赋值选中的菜单索引
      this.menuActiveIndex = index;
      this.$store.commit("setHeaderTitle", item.name);

      // 路由跳转
      this.$router.push({
        path: item.route,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-aside {
  cursor: default;
}

.logo {
  width: 100%;
  height: 120px;
  background: #fff;
  border-radius: 0 0 5px 0;
  display: flex;
  //justify-content: center;
  align-items: center;
  padding-left: 48px;
  box-sizing: border-box;
}

.space-name {
  margin-top: 5px;
  background: #fff;
  height: 60px;
  line-height: 60px;
  padding-left: 50px;
  box-sizing: border-box;
  color: #333;
  border-radius: 0 5px 5px 0;
  display: flex;
  align-items: center;

  &.active {
    background: #1b55f4;
    color: #fff;

    &:hover {
      background: #1b55f4;
      color: #fff;
    }
  }

  &:hover {
    background: #e2e9ff;
    //color: #fff;
  }

  img {
    width: 24px;
    height: 24px;
  }

  span {
    margin-left: 11px;
    font-size: 24px;
    font-weight: bold;
  }
}

.menu-wrap {
  margin-top: 5px;
  background: #fff;
  border-radius: 0 5px 0 0;
  height: calc(100vh - 120px - 70px);
  overflow: auto;

  .menu-top-msg {
    padding: 26px 0 17px 50px;
    font-size: 20px;
    font-weight: bold;
    color: #7a7b7c;
  }

  .menu {
    .menu-item {
      color: #333;
      padding-left: 50px;
      box-sizing: border-box;
      height: 58px;
      line-height: 58px;
      display: flex;
      align-items: center;

      &.active {
        background: #1b55f4;
        color: #fff;

        &:hover {
          background: #1b55f4;
          color: #fff;
        }
      }

      &:hover {
        background: #e2e9ff;
        //color: #fff;
      }

      img {
        width: 20px;
        height: 20px;
      }

      span {
        margin-left: 15px;
        font-size: 16px;
      }
    }
  }
}
</style>
